import sliderLoader from '../../vively/scripts/utils/slider-loader';
import SalesforceForm from '../../_common/scripts/salesforce-form';
import axios from 'axios';
import $ from 'jquery';

const Signup = () => {
  if (!window.route || !/^signup\//.test(window.route)) {
    return;
  }

  /* eslint-disable no-new */
  new SalesforceForm('.signup-form');

  // Sliders
  sliderLoader({
    slider: '#testimonials-slider',
    settings: {
      autoplaySpeed: 4000,
      pauseOnFocus: true,
      pauseOnHover: true,
      swipeToSlide: true,
      slidesToShow: 2,
      autoplay: true,
      arrows: false,
      dots: true,
      rows: 0,
      responsive: [
        {
          breakpoint: 670,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  sliderLoader({
    slider: '#plans-slider',
    maxWidth: 575,
    settings: {
      autoplaySpeed: 4000,
      pauseOnFocus: true,
      pauseOnHover: true,
      swipeToSlide: true,
      centerMode: true,
      initialSlide: 1,
      slidesToShow: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      rows: 0
    }
  });

  // Forms
  const $fixedAnchor = $('#fixed-anchor');
  const $signupForm = $('#signup-form');

  if ($fixedAnchor.length + $signupForm.length) {
    const $window = $(window);
    const $body = $('body');

    const toggleForms = function () {
      const bottomOfForm = $signupForm.offset().top + $signupForm.outerHeight();
      const topOfScreen = $window.scrollTop() + 100;
      if (topOfScreen < bottomOfForm) {
        $fixedAnchor.removeClass('active');
      } else {
        $fixedAnchor.addClass('active');
      }
    };

    ($body.hasClass('v2-body') || $body.hasClass('mm-wrapper') ? $body : $window).scroll(toggleForms);
    toggleForms();
  }

  // Practitioner
  $('.plan [data-amount]').on('click', function () {
    $('[name="00N2w000008uAbU"]').val($(this).data('amount'));
  });

  // Refer
  if (window.route === 'signup/refer') {
    const $statusModal = $('#status');
    const $successMessage = $statusModal.find('.status-success');
    const $errorMessage = $statusModal.find('.status-error');
    const parsleyMiddleware = callback => (e) => {
      if (e.$element.attr('id') === 'signup-form') {
        return callback(e);
      }
      return true;
    };
    const showMessage = (status) => {
      $statusModal.modal('show');
      if (status) {
        $successMessage.show();
        $errorMessage.hide();
      } else {
        $successMessage.hide();
        $errorMessage.show();
      }
    };

    window.Parsley
      .on('form:validated', parsleyMiddleware(({ $element }) => $element.removeClass('loading')))
      .on('form:validate', parsleyMiddleware(({ $element }) => $element.addClass('loading')))
      .on('form:submit', parsleyMiddleware(({ $element }) => {
        $element.addClass('loading');
        const data = {};

        // Preparing
        $.each($element.serializeArray(), (i, { name, value }) => {
          data[name] = value;
        });

        // Sending
        axios
          .post($element.attr('action'), data)
          .then(({ status, data: { success } }) => {
            $element.removeClass('loading');
            showMessage(status === 200 && success);
          })
          .catch(() => {
            $element.removeClass('loading');
            showMessage(false);
          });

        return false;
      }));
  }
};

export default Signup;




// WEBPACK FOOTER //
// ./signup/scripts/main.js